import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  en: {
    // Navbar
    nav_home: "Home",
    nav_book: "Book",
    nav_contact: "Register",
    nav_instagram: "Instagram",
    nav_faq: "FAQ",
    nav_tournaments: "Tournaments",
    nav_courts: "Court Booking",
    nav_admin: "Admin",
    nav_book_now: "Book Now",
    nav_cancel: "Cancel booking",

    // Hero
    hero_badge: "Beach Volleyball Academy · Agia Marina",
    hero_title_a: "The Sand Lab",
    hero_title_b: "Beach Volleyball",
    hero_title_c: "Academy.",
    hero_slogan: "Play under the sun.",
    hero_subtitle:
      "Train on the sand with our coaches — from your first serve to competitive play. Register your interest and we will find the right group for you.",
    hero_book_btn: "Register interest",
    hero_contact_btn: "Athlete login",
    hero_stat_duration: "Levels",
    hero_stat_hours: "Open hours",
    hero_stat_hours_val: "18:15 – 21:00, Saturday 08:30 – 10:00",
    hero_stat_court: "Court",
    hero_stat_court_val: "Sand · Net 2.43m",
    hero_scroll: "Scroll",

    // Reservation
    res_section_label: "Reservations",
    res_title_a: "Pick your date.",
    res_title_b: "Pick your slot.",
    res_subtitle:
      "Sessions last 1 hour and 30 minutes. Choose any green slot — reserved and admin-blocked slots are shown for transparency.",
    res_select_date: "Select date",
    res_time_slots: "time slots",
    res_legend_available: "Available",
    res_legend_reserved: "Reserved",
    res_legend_blocked: "Blocked",
    res_your_details: "Your details",
    res_no_account: "No account needed. We just need a way to reach you.",
    res_fullname: "Full name",
    res_email: "Email",
    res_phone: "Phone",
    res_booking: "Booking",
    res_at: "at",
    res_select_prompt: "Select a green slot above to continue.",
    res_confirm: "Confirm reservation",
    res_booking_loading: "Booking...",
    res_status_available: "available",
    res_status_reserved: "reserved",
    res_status_blocked: "blocked",
    res_could_not_load: "Could not load availability",
    res_fill_fields: "Please fill in all fields",
    res_select_slot: "Please select an available slot",
    res_booking_failed: "Booking failed",
    res_email_taken: "This email already has a reservation on this date",
    res_email_required: "Email is required",

    // Training - general
    train_nav: "Training",
    train_login_title: "Athlete login",
    train_login_subtitle: "Sign in to book your training sessions.",
    train_username: "Username",
    train_password: "Password",
    train_signin: "Sign in",
    train_forgot: "Forgot password?",
    train_reset_title: "Reset your password",
    train_reset_subtitle: "Enter your username and the email used at registration to set a new password.",
    train_new_password: "New password",
    train_reset_btn: "Reset password",
    train_reset_success: "Password reset! You can now sign in.",
    train_reset_no_match: "Username and email do not match any account",
    train_no_account: "Have an invite link?",
    train_register_btn: "Open invite",
    train_register_title: "Create your athlete account",
    train_register_subtitle: "You've been invited to join. Complete your profile to start booking.",
    train_name: "First name",
    train_surname: "Last name",
    train_email: "Email",
    train_create_account: "Create account",
    train_invalid_invite: "Invalid or expired invite link",
    train_logout: "Logout",
    train_my_bookings: "My bookings",
    train_no_bookings: "No upcoming bookings.",
    train_slots_title: "Upcoming slots",
    train_book: "Book",
    train_cancel: "Cancel",
    train_join_waitlist: "Join Waitlist",
    train_on_waitlist: "On waitlist",
    train_leave_waitlist: "Leave waitlist",
    train_waitlist_position: "Waitlist",
    train_waitlist_joined: "You joined the waitlist",
    train_waitlist_left: "You left the waitlist",
    train_booked: "Booked",
    train_full: "Full",
    train_past: "Past",
    train_locked_level: "Golden only",
    train_starts_at: "starts at",
    train_capacity: "athletes",
    train_my_month: "This month",
    train_total: "Total",
    train_sessions: "sessions",
    train_view_athletes: "View athletes",
    train_no_athletes_booked: "No athletes booked yet.",
    train_cancel_rule: "Cancellations are not allowed less than 12 hours before training.",
    train_profile: "My profile",
    train_profile_title: "Account info",
    train_change_password: "Change password",
    train_current_password: "Current password",
    train_save: "Save",
    train_password_changed: "Password changed successfully",
    train_password_mismatch: "Passwords do not match",
    train_close: "Close",
    train_breakdown_subtitle: "Breakdown by month",
    train_no_history: "No bookings yet.",
    coach_add_athlete: "Add athlete last-minute",
    coach_pick_athlete: "Pick an athlete",
    coach_no_more_athletes: "No available athletes to add.",
    coach_athlete_added: "Athlete added to slot",
    coach_athlete_inactive: "Inactive",
    coach_athlete_enabled: "Athlete enabled",
    coach_athlete_disabled: "Athlete disabled",
    coach_enable: "Enable athlete",
    coach_disable: "Disable athlete (won't receive emails or book)",
    coach_confirm_delete_athlete: "Delete this athlete?",
    coach_athlete_deleted: "Athlete deleted",

    // Training coach
    coach_tab_users: "Users",
    coach_tab_slots: "Slots",
    coach_tab_attendance: "Attendance",
    coach_tab_invites: "Invites",
    coach_invites_title: "Invite athletes",
    coach_invite_create: "Generate invite link",
    coach_invite_copy: "Copy link",
    coach_invite_copied: "Link copied!",
    coach_users_title: "Athletes",
    coach_users_empty: "No athletes yet. Generate an invite link.",
    coach_delete_athlete: "Delete athlete",
    coach_slots_title: "Training slots",
    coach_slots_generate: "Generate next weeks",
    coach_add_day: "Add slot",
    coach_add_day_helper: "Pick date, time and (optional) athletes",
    coach_slots_empty: "No upcoming slots.",
    coach_attendance_title: "Monthly attendance",
    coach_attendance_empty: "No completed sessions this month.",

    // Confirmation dialog
    conf_title: "You're booked!",
    conf_subtitle:
      "Your court reservation has been confirmed. See you on the sand.",
    conf_name: "Name",
    conf_date: "Date",
    conf_time: "Time",
    conf_email: "Email",
    conf_phone: "Phone",
    conf_reference: "Reference",
    conf_ok: "Awesome",

    // Cancel dialog
    cancel_title: "Cancel a reservation",
    cancel_subtitle:
      "Enter the email you used when booking. We'll show your upcoming reservations.",
    cancel_lookup: "Find my bookings",
    cancel_loading: "Searching...",
    cancel_no_results:
      "No upcoming reservations found for this email.",
    cancel_button: "Cancel",
    cancel_confirm_q: "Cancel this reservation?",
    cancel_confirm_yes: "Yes, cancel",
    cancel_confirm_no: "Keep it",
    cancel_success: "Reservation cancelled",
    cancel_failed: "Could not cancel reservation",
    cancel_close: "Close",
    cancel_email_placeholder: "your@email.com",
    cancel_invalid_email: "Please enter a valid email",
    cancel_email_mismatch: "Email does not match this reservation",

    // Contact
    contact_label: "Contact & Location",
    contact_title_a: "Find us on",
    contact_title_b: "the beach.",
    contact_subtitle:
      "Bring sunscreen, water, and your A-game. We provide the net, the ball, and the sand.",
    contact_address_label: "The Sand Lab",
    contact_address: "Agia Marina 730 14, Greece",
    contact_phone: "Phone",
    contact_website: "Website",
    contact_email: "Email",
    contact_open: "Open",
    contact_open_val: "18:15 – 21:00 · Saturday 08:30 – 10:00",
    contact_directions: "Get directions",

    // Instagram
    ig_label: "@the_sand_lab",
    ig_title_a: "Sunsets, spikes &",
    ig_title_b: "sandy moments.",
    ig_follow: "Follow us",

    // FAQ
    faq_label: "Frequently Asked",
    faq_title_a: "Everything you need",
    faq_title_b: "before you play.",
    faq_q1: "How do I join the academy?",
    faq_a1:
      "Fill in the registration form with your name, phone, email and training level. Our coach will contact you to arrange your first session.",
    faq_q2: "How long is a training session?",
    faq_a2:
      "Training sessions last about 1 hour and 30 minutes. Groups train on set days and times, which the coach shares with you after registration.",
    faq_q3: "Which level should I choose?",
    faq_a3:
      "Silver if you are new or intermediate and want fun plus technique work, Golden if you play competitively and want high intensity. Not sure? Pick the closest one — the coach will adjust after your first session.",
    faq_q4: "How many players can use the court?",
    faq_a4:
      "Groups are small so everyone gets plenty of touches on the ball. Training is organised by level so you play with athletes at a similar stage.",
    faq_q5: "Is there equipment available?",
    faq_a5:
      "Yes. The net is set up, and a ball is provided. You may also bring your own gear.",
    faq_q6: "Do I pay online when registering?",
    faq_a6:
      "No. Registering your interest is free and does not commit you to anything. Pricing and payment are discussed with the coach in person.",

    // Footer
    footer_blurb:
      "The Sand Lab Beach Volleyball Academy in Agia Marina. Endless games — built on Greek sand, open daily from sunrise warm-ups to sunset rallies.",
    footer_explore: "Explore",
    footer_court: "Court",
    footer_court_hours: "18:15 – 21:00 · Sat 08:30 – 10:00",
    footer_court_session: "Training for all levels",
    footer_court_net: "Net height 2.43m",
    footer_admin: "Admin login",
    footer_copy: "All rights reserved.",
    // Registration
    reg_label: "Join the Academy",
    reg_title_a: "Register your",
    reg_title_b: "interest.",
    reg_subtitle: "Tell us a bit about you and your level. Our coach will contact you to find the right training group for you.",
    reg_first_name: "First name",
    reg_last_name: "Last name",
    reg_phone: "Phone number",
    reg_email: "Email",
    reg_level: "Training level",
    reg_level_placeholder: "Select your level",
    reg_level_silver: "Silver",
    reg_level_silver_desc: "For beginners and intermediate players — a mix of fun and technique improvement.",
    reg_level_golden: "Golden",
    reg_level_golden_desc: "For advanced, competitive players who want high-intensity training.",
    reg_submit: "Send registration",
    reg_sending: "Sending…",
    reg_privacy: "We use your details only to contact you about training at The Sand Lab.",
    reg_success_title: "Thank you",
    reg_success_body: "Your registration has been received. Our coach will get in touch with you soon by phone or email.",
    reg_another: "Register another player",
    reg_error: "Something went wrong. Please try again.",

    footer_motto: "Play under the sun.",

    // DataVolley
    nav_datavolley: "DataVolley",
    dv_matches: "Matches",
    dv_players: "Players",
    dv_live: "Live",
    dv_stats: "Stats",
    dv_new_match: "New match",
    dv_opponent: "Opponent",
    dv_date: "Date",
    dv_venue: "Venue",
    dv_home: "Home",
    dv_away: "Away",
    dv_competition: "Competition (optional)",
    dv_select_players: "Players in this match",
    dv_create: "Create match",
    dv_cancel: "Cancel",
    dv_delete: "Delete",
    dv_open: "Open live",
    dv_number: "Number",
    dv_name: "Name",
    dv_position: "Position",
    dv_add_player: "Add player",
    dv_save: "Save",
    dv_edit: "Edit",
    dv_no_players: "No players yet. Add your roster to start recording.",
    dv_no_matches: "No matches yet. Create your first match.",
    dv_reception: "RECEPTION",
    dv_attack: "ATTACK",
    dv_serve: "SERVE",
    dv_block: "BLOCK",
    dv_pct: "PERCENTAGES",
    dv_rec_pct: "Rec %",
    dv_att_pct: "Att %",
    dv_excellent: "Excellent",
    dv_medium: "In Play",
    dv_poor: "Poor",
    dv_point: "Point",
    dv_inplay: "In Play",
    dv_error: "Error",
    dv_ace: "Ace",
    dv_passed: "In Play",
    dv_missed: "Missed",
    dv_team_totals: "TEAM TOTALS",
    dv_reset_set: "Reset set",
    dv_reset_confirm: "Delete all actions recorded in this set? This cannot be undone.",
    dv_undo: "Undo",
    dv_undo_sub: "last action",
    dv_view_stats: "View stats",
    dv_total_rec: "Receptions",
    dv_total_att: "Attacks",
    dv_total_srv: "Serves",
    dv_total_blk: "Blocks",
    dv_match: "MATCH",
    dv_aces: "Aces",
    dv_blocks: "Blocks",
    dv_export_csv: "Export CSV",
    dv_pending: "pending sync",
    dv_offline: "Offline",
    dv_synced: "Synced",
    dv_finished: "Finished",
    dv_live_status: "Live",
    dv_mark_finished: "Mark finished",
    dv_reopen: "Reopen",
    dv_delete_match_confirm: "Delete this match and all its statistics?",
    dv_back: "Back",
    dv_player: "Player",
    dv_team: "Team",
    dv_roster: "Roster",
    dv_logout: "Logout",
    dv_login_hint: "DataVolley · Coach access",
    dv_select_set_hint: "Select a set to record actions",
    dv_login_first: "Sign in with your admin account to use DataVolley.",
    dv_season: "Season",
    dv_progress: "Player progress",
    dv_season_avg: "season",
    dv_export_pdf: "Export PDF",
    dv_set_scores: "Set scores (us - opponent)",
    dv_coach_login: "Coach login",
    footer_dv_public: "Team stats",
    dv_end_set: "End of set",
    dv_end_set_hint: "Enter the final score of this set. You can change it later from Edit match.",
    dv_set_score: "Set score",
    dv_match_decided: "Match decided",
    dv_err_min_points: "The winning team needs at least {n} points",
    dv_err_diff: "The set must be won by at least 2 points",
    dv_err_exact_two: "Above {n} points the set is won by exactly 2 points (e.g. 26-24)",
    dv_score_invalid: "Invalid set score",
    landing_cta_academy: "Enter the Academy",
    dv_set: "SETTING",
    dv_set_label: "Setting",
    dv_set_good: "Good",
    dv_set_pct: "Setting %",
    dv_errors: "Errors",
    nav_landing: "Home",
    landing_cta_naos: "Team & statistics",
    dv_all_sections: "Home",
    dv_finish_match_q: "The match is over. Mark it as finished?",
    dv_finish_match: "Finish match",
    dv_not_now: "Not now",
    dv_set_locked: "This set is not played — the match ended",
    dv_set_scores_hint: "Optional. Used for the final result in the match report.",
  },
  el: {
    // Navbar
    nav_home: "Αρχική",
    nav_book: "Κράτηση",
    nav_contact: "Εγγραφή",
    nav_instagram: "Instagram",
    nav_faq: "Συχνές ερωτήσεις",
    nav_tournaments: "Τουρνουά",
    nav_courts: "Κρατήσεις",
    nav_admin: "Admin",
    nav_book_now: "Κλείσε τώρα",
    nav_cancel: "Ακύρωση κράτησης",

    // Hero
    hero_badge: "Ακαδημία Beach Volleyball · Αγία Μαρίνα",
    hero_title_a: "The Sand Lab",
    hero_title_b: "Beach Volleyball",
    hero_title_c: "Academy.",
    hero_slogan: "Παίξε κάτω από τον ήλιο.",
    hero_subtitle:
      "Προπονήσου στην άμμο με τους προπονητές μας — από το πρώτο σερβίς μέχρι το αγωνιστικό παιχνίδι. Δήλωσε ενδιαφέρον και θα βρούμε το κατάλληλο τμήμα για σένα.",
    hero_book_btn: "Δήλωσε ενδιαφέρον",
    hero_contact_btn: "Είσοδος αθλητή",
    hero_stat_duration: "Επίπεδα",
    hero_stat_hours: "Ωράριο",
    hero_stat_hours_val: "18:15 – 21:00, Σάββατο 08:30 – 10:00",
    hero_stat_court: "Γήπεδο",
    hero_stat_court_val: "Άμμος · Φιλέ 2.43μ",
    hero_scroll: "Scroll",

    // Reservation
    res_section_label: "Κρατήσεις",
    res_title_a: "Διάλεξε ημερομηνία.",
    res_title_b: "Διάλεξε ώρα.",
    res_subtitle:
      "Κάθε κράτηση διαρκεί 1 ώρα και 30 λεπτά. Διάλεξε οποιοδήποτε πράσινο slot — οι κρατημένες και μπλοκαρισμένες ώρες εμφανίζονται για διαφάνεια.",
    res_select_date: "Διάλεξε ημερομηνία",
    res_time_slots: "ώρες",
    res_legend_available: "Διαθέσιμο",
    res_legend_reserved: "Κρατημένο",
    res_legend_blocked: "Μπλοκαρισμένο",
    res_your_details: "Τα στοιχεία σου",
    res_no_account: "Χωρίς λογαριασμό. Θέλουμε μόνο έναν τρόπο επικοινωνίας.",
    res_fullname: "Ονοματεπώνυμο",
    res_email: "Email",
    res_phone: "Τηλέφωνο",
    res_booking: "Κράτηση",
    res_at: "στις",
    res_select_prompt: "Διάλεξε ένα πράσινο slot παραπάνω για να συνεχίσεις.",
    res_confirm: "Επιβεβαίωση κράτησης",
    res_booking_loading: "Κράτηση...",
    res_status_available: "διαθέσιμο",
    res_status_reserved: "κρατημένο",
    res_status_blocked: "μπλοκαρισμένο",
    res_could_not_load: "Δεν φόρτωσαν οι διαθεσιμότητες",
    res_fill_fields: "Συμπλήρωσε όλα τα πεδία",
    res_select_slot: "Διάλεξε ένα διαθέσιμο slot",
    res_booking_failed: "Η κράτηση απέτυχε",
    res_email_taken: "Αυτό το email έχει ήδη κράτηση για αυτή την ημερομηνία",
    res_email_required: "Το email είναι υποχρεωτικό",

    // Training - general
    train_nav: "Προπονήσεις",
    train_login_title: "Είσοδος αθλητή",
    train_login_subtitle: "Συνδέσου για να κλείσεις προπονήσεις.",
    train_username: "Username",
    train_password: "Κωδικός",
    train_signin: "Σύνδεση",
    train_forgot: "Ξέχασες τον κωδικό;",
    train_reset_title: "Επαναφορά κωδικού",
    train_reset_subtitle: "Δώσε το username σου και το email της εγγραφής για να ορίσεις νέο κωδικό.",
    train_new_password: "Νέος κωδικός",
    train_reset_btn: "Επαναφορά κωδικού",
    train_reset_success: "Ο κωδικός άλλαξε! Μπορείς να συνδεθείς τώρα.",
    train_reset_no_match: "Username και email δεν αντιστοιχούν σε λογαριασμό",
    train_no_account: "Έχεις invite link;",
    train_register_btn: "Άνοιξε το invite",
    train_register_title: "Δημιουργία λογαριασμού αθλητή",
    train_register_subtitle: "Έχεις προσκληθεί. Συμπλήρωσε το προφίλ σου.",
    train_name: "Όνομα",
    train_surname: "Επώνυμο",
    train_email: "Email",
    train_create_account: "Δημιουργία λογαριασμού",
    train_invalid_invite: "Μη έγκυρο ή ληγμένο invite",
    train_logout: "Αποσύνδεση",
    train_my_bookings: "Οι κρατήσεις μου",
    train_no_bookings: "Δεν έχεις προσεχείς κρατήσεις.",
    train_slots_title: "Προσεχείς προπονήσεις",
    train_book: "Κράτηση",
    train_cancel: "Ακύρωση",
    train_join_waitlist: "Join Waitlist",
    train_on_waitlist: "Στη λίστα αναμονής",
    train_leave_waitlist: "Έξοδος από waitlist",
    train_waitlist_position: "Waitlist",
    train_waitlist_joined: "Μπήκες στη λίστα αναμονής",
    train_waitlist_left: "Έφυγες από τη λίστα αναμονής",
    train_booked: "Κρατήθηκε",
    train_full: "Πλήρες",
    train_past: "Παρελθόν",
    train_locked_level: "Μόνο για Golden",
    train_starts_at: "ξεκινά στις",
    train_capacity: "αθλητές",
    train_my_month: "Αυτόν τον μήνα",
    train_total: "Σύνολο",
    train_sessions: "προπονήσεις",
    train_view_athletes: "Δες αθλητές",
    train_no_athletes_booked: "Κανείς δεν έχει κάνει κράτηση ακόμα.",
    train_cancel_rule: "Η ακύρωση δεν επιτρέπεται λιγότερο από 12 ώρες πριν την προπόνηση.",
    train_profile: "Στοιχεία μου",
    train_profile_title: "Στοιχεία λογαριασμού",
    train_change_password: "Αλλαγή κωδικού",
    train_current_password: "Τρέχων κωδικός",
    train_save: "Αποθήκευση",
    train_password_changed: "Ο κωδικός άλλαξε επιτυχώς",
    train_password_mismatch: "Οι κωδικοί δεν ταιριάζουν",
    train_close: "Κλείσιμο",
    train_breakdown_subtitle: "Ανάλυση ανά μήνα",
    train_no_history: "Δεν υπάρχουν κρατήσεις ακόμα.",
    coach_add_athlete: "Προσθήκη αθλητή τελευταίας στιγμής",
    coach_pick_athlete: "Επίλεξε αθλητή",
    coach_no_more_athletes: "Δεν υπάρχουν διαθέσιμοι αθλητές για προσθήκη.",
    coach_athlete_added: "Ο αθλητής προστέθηκε στην προπόνηση",
    coach_athlete_inactive: "Ανενεργός",
    coach_athlete_enabled: "Ο αθλητής ενεργοποιήθηκε",
    coach_athlete_disabled: "Ο αθλητής απενεργοποιήθηκε",
    coach_enable: "Ενεργοποίηση αθλητή",
    coach_disable: "Απενεργοποίηση αθλητή (δεν θα λαμβάνει emails ούτε θα κάνει κρατήσεις)",
    coach_confirm_delete_athlete: "Διαγραφή αθλητή;",
    coach_athlete_deleted: "Ο αθλητής διαγράφηκε",

    // Training coach
    coach_tab_users: "Αθλητές",
    coach_tab_slots: "Προπονήσεις",
    coach_tab_attendance: "Παρουσίες",
    coach_tab_invites: "Προσκλήσεις",
    coach_invites_title: "Προσκάλεσε αθλητές",
    coach_invite_create: "Δημιουργία invite link",
    coach_invite_copy: "Αντιγραφή",
    coach_invite_copied: "Αντιγράφηκε!",
    coach_users_title: "Αθλητές",
    coach_users_empty: "Κανείς αθλητής. Δημιούργησε ένα invite.",
    coach_delete_athlete: "Διαγραφή αθλητή",
    coach_slots_title: "Slots προπονήσεων",
    coach_slots_generate: "Δημιουργία επόμενων εβδομάδων",
    coach_add_day: "Προσθήκη slot",
    coach_add_day_helper: "Διάλεξε ημερομηνία, ώρα και (προαιρετικά) αθλητές",
    coach_slots_empty: "Δεν υπάρχουν προσεχή slots.",
    coach_attendance_title: "Μηνιαίες παρουσίες",
    coach_attendance_empty: "Δεν υπάρχουν ολοκληρωμένες προπονήσεις αυτόν τον μήνα.",

    // Confirmation dialog
    conf_title: "Είσαι μέσα!",
    conf_subtitle: "Η κράτηση επιβεβαιώθηκε. Τα λέμε στην άμμο.",
    conf_name: "Όνομα",
    conf_date: "Ημερομηνία",
    conf_time: "Ώρα",
    conf_email: "Email",
    conf_phone: "Τηλέφωνο",
    conf_reference: "Κωδικός",
    conf_ok: "Τέλεια",

    // Cancel dialog
    cancel_title: "Ακύρωση κράτησης",
    cancel_subtitle:
      "Δώσε το email που χρησιμοποίησες κατά την κράτηση. Θα δούμε τις προσεχείς κρατήσεις σου.",
    cancel_lookup: "Βρες τις κρατήσεις μου",
    cancel_loading: "Αναζήτηση...",
    cancel_no_results:
      "Δεν βρέθηκαν προσεχείς κρατήσεις με αυτό το email.",
    cancel_button: "Ακύρωση",
    cancel_confirm_q: "Ακύρωση αυτής της κράτησης;",
    cancel_confirm_yes: "Ναι, ακύρωσε",
    cancel_confirm_no: "Κράτησέ την",
    cancel_success: "Η κράτηση ακυρώθηκε",
    cancel_failed: "Η ακύρωση απέτυχε",
    cancel_close: "Κλείσιμο",
    cancel_email_placeholder: "your@email.com",
    cancel_invalid_email: "Δώσε ένα έγκυρο email",
    cancel_email_mismatch: "Το email δεν ταιριάζει με αυτή την κράτηση",

    // Contact
    contact_label: "Επικοινωνία & Τοποθεσία",
    contact_title_a: "Βρες μας",
    contact_title_b: "στην παραλία.",
    contact_subtitle:
      "Φέρε αντηλιακό, νερό και τη φόρμα σου. Εμείς προσφέρουμε δίχτυ, μπάλα και άμμο.",
    contact_address_label: "The Sand Lab",
    contact_address: "Αγία Μαρίνα 730 14, Ελλάδα",
    contact_phone: "Τηλέφωνο",
    contact_website: "Ιστοσελίδα",
    contact_email: "Email",
    contact_open: "Ωράριο",
    contact_open_val: "18:15 – 21:00 · Σάββατο 08:30 – 10:00",
    contact_directions: "Οδηγίες πρόσβασης",

    // Instagram
    ig_label: "@the_sand_lab",
    ig_title_a: "Ηλιοβασιλέματα, καρφιά &",
    ig_title_b: "στιγμές στην άμμο.",
    ig_follow: "Ακολούθησε μας",

    // FAQ
    faq_label: "Συχνές ερωτήσεις",
    faq_title_a: "Όλα όσα πρέπει να ξέρεις",
    faq_title_b: "πριν παίξεις.",
    faq_q1: "Πώς γίνομαι μέλος της ακαδημίας;",
    faq_a1:
      "Συμπλήρωσε τη φόρμα εγγραφής με όνομα, τηλέφωνο, email και επίπεδο. Ο προπονητής θα επικοινωνήσει μαζί σου για την πρώτη σου προπόνηση.",
    faq_q2: "Πόσο διαρκεί μια προπόνηση;",
    faq_a2:
      "Οι προπονήσεις διαρκούν περίπου 1 ώρα και 30 λεπτά. Τα τμήματα προπονούνται σε σταθερές μέρες και ώρες που θα σου ανακοινώσει ο προπονητής μετά την εγγραφή.",
    faq_q3: "Ποιο επίπεδο να επιλέξω;",
    faq_a3:
      "Silver αν ξεκινάς ή παίζεις για διασκέδαση και θέλεις να βελτιώσεις την τεχνική σου, Golden αν παίζεις αγωνιστικά και θέλεις υψηλή ένταση. Δεν είσαι σίγουρος; Διάλεξε το πιο κοντινό — ο προπονητής θα το προσαρμόσει μετά την πρώτη προπόνηση.",
    faq_q4: "Πόσοι παίκτες χωράνε στο γήπεδο;",
    faq_a4:
      "Τα τμήματα είναι μικρά ώστε όλοι να έχουν πολλές επαφές με την μπάλα. Οι προπονήσεις οργανώνονται ανά επίπεδο για να παίζεις με αθλητές στο ίδιο στάδιο.",
    faq_q5: "Υπάρχει διαθέσιμος εξοπλισμός;",
    faq_a5:
      "Ναι. Το δίχτυ είναι στημένο και παρέχεται μπάλα. Μπορείς να φέρεις και τον δικό σου εξοπλισμό.",
    faq_q6: "Πληρώνω online με την εγγραφή;",
    faq_a6:
      "Όχι. Η δήλωση ενδιαφέροντος είναι δωρεάν και δεν σε δεσμεύει. Τιμές και πληρωμή συζητούνται με τον προπονητή.",

    // Footer
    footer_blurb:
      "The Sand Lab Beach Volleyball Academy στην Αγία Μαρίνα. Ατελείωτα παιχνίδια σε ελληνική άμμο, ανοιχτό κάθε μέρα από το πρωί μέχρι το ηλιοβασίλεμα.",
    footer_explore: "Περιήγηση",
    footer_court: "Γήπεδο",
    footer_court_hours: "18:15 – 21:00 · Σάβ. 08:30 – 10:00",
    footer_court_session: "Προπονήσεις για όλα τα επίπεδα",
    footer_court_net: "Δίχτυ 2.43μ",
    footer_admin: "Είσοδος Admin",
    footer_copy: "Με επιφύλαξη παντός δικαιώματος.",
    // Registration
    reg_label: "Γίνε μέλος της Ακαδημίας",
    reg_title_a: "Δήλωσε το",
    reg_title_b: "ενδιαφέρον σου.",
    reg_subtitle: "Πες μας λίγα λόγια για σένα και το επίπεδό σου. Ο προπονητής μας θα επικοινωνήσει μαζί σου για να βρούμε το κατάλληλο τμήμα.",
    reg_first_name: "Όνομα",
    reg_last_name: "Επώνυμο",
    reg_phone: "Τηλέφωνο",
    reg_email: "Email",
    reg_level: "Επίπεδο προπόνησης",
    reg_level_placeholder: "Επίλεξε επίπεδο",
    reg_level_silver: "Silver",
    reg_level_silver_desc: "Για αρχάριους και μεσαίου επιπέδου παίκτες — συνδυασμός διασκέδασης και βελτίωσης τεχνικής.",
    reg_level_golden: "Golden",
    reg_level_golden_desc: "Για προχωρημένους, αγωνιστικούς παίκτες που θέλουν προπόνηση υψηλής έντασης.",
    reg_submit: "Αποστολή εγγραφής",
    reg_sending: "Αποστολή…",
    reg_privacy: "Τα στοιχεία σου χρησιμοποιούνται μόνο για επικοινωνία σχετικά με τις προπονήσεις στο The Sand Lab.",
    reg_success_title: "Ευχαριστούμε",
    reg_success_body: "Η εγγραφή σου καταχωρήθηκε. Ο προπονητής μας θα επικοινωνήσει σύντομα μαζί σου τηλεφωνικά ή με email.",
    reg_another: "Εγγραφή άλλου παίκτη",
    reg_error: "Κάτι πήγε στραβά. Δοκίμασε ξανά.",

    footer_motto: "Παίξε κάτω από τον ήλιο.",

    // DataVolley
    nav_datavolley: "DataVolley",
    dv_matches: "Αγώνες",
    dv_players: "Παίκτες",
    dv_live: "Live",
    dv_stats: "Στατιστικά",
    dv_new_match: "Νέος αγώνας",
    dv_opponent: "Αντίπαλος",
    dv_date: "Ημερομηνία",
    dv_venue: "Έδρα",
    dv_home: "Εντός",
    dv_away: "Εκτός",
    dv_competition: "Διοργάνωση (προαιρετικά)",
    dv_select_players: "Παίκτες που συμμετέχουν",
    dv_create: "Δημιουργία αγώνα",
    dv_cancel: "Άκυρο",
    dv_delete: "Διαγραφή",
    dv_open: "Άνοιγμα live",
    dv_number: "Αριθμός",
    dv_name: "Όνομα",
    dv_position: "Θέση",
    dv_add_player: "Προσθήκη παίκτη",
    dv_save: "Αποθήκευση",
    dv_edit: "Επεξεργασία",
    dv_no_players: "Δεν υπάρχουν παίκτες. Πρόσθεσε το ρόστερ για να ξεκινήσεις.",
    dv_no_matches: "Δεν υπάρχουν αγώνες. Δημιούργησε τον πρώτο αγώνα.",
    dv_reception: "ΥΠΟΔΟΧΗ",
    dv_attack: "ΕΠΙΘΕΣΗ",
    dv_serve: "ΣΕΡΒΙΣ",
    dv_block: "ΜΠΛΟΚ",
    dv_pct: "ΠΟΣΟΣΤΑ",
    dv_rec_pct: "Υποδοχή %",
    dv_att_pct: "Επίθεση %",
    dv_excellent: "Άριστη",
    dv_medium: "Παίζει",
    dv_poor: "Κακή",
    dv_point: "Πόντος",
    dv_inplay: "Παίζει",
    dv_error: "Λάθος",
    dv_ace: "Άσσος",
    dv_passed: "Παίζει",
    dv_missed: "Χαμένο",
    dv_team_totals: "ΣΥΝΟΛΑ ΟΜΑΔΑΣ",
    dv_reset_set: "Μηδενισμός Set",
    dv_reset_confirm: "Να διαγραφούν όλες οι ενέργειες αυτού του set? Δεν μπορεί να αναιρεθεί.",
    dv_undo: "Undo",
    dv_undo_sub: "τελευταίας ενέργειας",
    dv_view_stats: "Προβολή Στατιστικών",
    dv_total_rec: "Σύνολο Υποδοχών",
    dv_total_att: "Σύνολο Επιθέσεων",
    dv_total_srv: "Σύνολο Σερβίς",
    dv_total_blk: "Συνολικά Μπλοκ",
    dv_match: "ΑΓΩΝΑΣ",
    dv_aces: "Άσσοι",
    dv_blocks: "Μπλοκ",
    dv_export_csv: "Export CSV",
    dv_pending: "σε αναμονή συγχρονισμού",
    dv_offline: "Offline",
    dv_synced: "Συγχρονισμένο",
    dv_finished: "Ολοκληρώθηκε",
    dv_live_status: "Live",
    dv_mark_finished: "Ολοκλήρωση αγώνα",
    dv_reopen: "Επαναφορά",
    dv_delete_match_confirm: "Να διαγραφεί ο αγώνας και όλα τα στατιστικά του?",
    dv_back: "Πίσω",
    dv_player: "Παίκτης",
    dv_team: "Ομάδα",
    dv_roster: "Ρόστερ",
    dv_logout: "Αποσύνδεση",
    dv_login_hint: "DataVolley · Πρόσβαση προπονητή",
    dv_select_set_hint: "Επίλεξε set για να καταγράψεις ενέργειες",
    dv_login_first: "Συνδέσου με τον λογαριασμό admin για να χρησιμοποιήσεις το DataVolley.",
    dv_season: "Σεζόν",
    dv_progress: "Πορεία παικτριών",
    dv_season_avg: "σεζόν",
    dv_export_pdf: "Export PDF",
    dv_set_scores: "Σκορ ανά set (εμείς - αντίπαλος)",
    dv_coach_login: "Είσοδος προπονητή",
    footer_dv_public: "Στατιστικά ομάδας",
    dv_end_set: "Τέλος set",
    dv_end_set_hint: "Γράψε το τελικό σκορ του set. Μπορείς να το αλλάξεις αργότερα από την Επεξεργασία αγώνα.",
    dv_set_score: "Σκορ set",
    dv_match_decided: "Ο αγώνας κρίθηκε",
    dv_err_min_points: "Ο νικητής χρειάζεται τουλάχιστον {n} πόντους",
    dv_err_diff: "Το set κερδίζεται με διαφορά τουλάχιστον 2 πόντων",
    dv_err_exact_two: "Πάνω από τους {n} πόντους το set κερδίζεται με διαφορά ακριβώς 2 (π.χ. 26-24)",
    dv_score_invalid: "Μη έγκυρο σκορ set",
    landing_cta_academy: "Είσοδος στην Ακαδημία",
    dv_set: "ΠΑΣΑ",
    dv_set_label: "Πάσα",
    dv_set_good: "Σωστή",
    dv_set_pct: "Πάσα %",
    dv_errors: "Λάθη",
    nav_landing: "Αρχική",
    landing_cta_naos: "Ομάδα & στατιστικά",
    dv_all_sections: "Αρχική",
    dv_finish_match_q: "Ο αγώνας τελείωσε. Να σημειωθεί ως ολοκληρωμένος?",
    dv_finish_match: "Ολοκλήρωση αγώνα",
    dv_not_now: "Όχι τώρα",
    dv_set_locked: "Το set δεν παίζεται — ο αγώνας έχει κριθεί",
    dv_set_scores_hint: "Προαιρετικό. Χρησιμοποιείται για το τελικό αποτέλεσμα στην αναφορά αγώνα.",
  },
};

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: (k) => k,
});

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(
    () => localStorage.getItem("sandlab_lang") || "en"
  );
  useEffect(() => {
    localStorage.setItem("sandlab_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const setLang = (l) => setLangState(l);
  const t = (key) => dict[lang]?.[key] ?? dict.en[key] ?? key;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useT = () => useContext(LanguageContext);
